import { useState } from "react";
import { BetaTag } from "@design-system/BetaTag/BetaTag";
import { TextControl } from "./playgroundControls";
import { SandboxLayout } from "./SandboxLayout";
import { ShowcasePreview } from "./ShowcasePreview";
import styles from "./FeedbackPlayground.module.scss";

export const BetaTagPlayground = () => {
    const [tooltip, setTooltip] = useState(
        "This feature is still in beta. Send us your feedback.",
    );

    return (
        <SandboxLayout
            controls={
                <section>
                    <h2>Content</h2>
                    <TextControl
                        label="Tooltip"
                        value={tooltip}
                        onChange={setTooltip}
                    />
                </section>
            }
        >
            <ShowcasePreview
                summary="Hover the tag"
                output={JSON.stringify(
                    { tooltip: tooltip || undefined },
                    null,
                    2,
                )}
            >
                <h2 className={styles.heading}>
                    Accrual bills
                    <BetaTag tooltip={tooltip || undefined} />
                </h2>
            </ShowcasePreview>
        </SandboxLayout>
    );
};
